module.exports = __webpack_public_path__ + "img/talron-service-station.de05e5be.svg";